import React, { useCallback, useState, useContext } from 'react';
import TicketContainer from '@nile/mangifera/src/Containers/TableContainers/TicketContainer';
import TaskViewContainer from '@nile/mangifera/src/Containers/TableContainers/TaskViewContainer';
import TaskKanbanBoard from '@nile/mangifera/src/Containers/PageContainers/TaskKanbanBoard';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { SkeletonTableLoading } from '@nile/components';

function TaskListContainer(props) {
  const context = useContext(TicketContext);
  const {
    ticketViews,
    ticketViewMeta,
    entityProperties,
    taskViews,
    taskMeta,
    taskViewMeta,
    allEntities
  } = props;
  const { taskViewType } = context;

  if (context.viewTypeLoading) return <SkeletonTableLoading />;

  if (taskViewType === 'kanban') {
    // return 'Kanban';
    return (
      <TaskKanbanBoard
        allEntities={allEntities}
        ticketViews={ticketViews}
        taskViews={taskViews}
        taskViewMeta={taskViewMeta}
      />
    );
  }
  return (
    <TaskViewContainer
      allEntities={allEntities}
      ticketViews={ticketViews}
      taskViews={taskViews}
      taskViewMeta={taskViewMeta}
    />
  );
}

export default TaskListContainer;
